/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class DeletePopoverModel  {
        isOpen: boolean = false;

        constructor(
            private deleteCallback: (index: number) => void,
            private name: string,
            private index: number) { }

        public open() : void {
            this.isOpen = true;
        }

        public close() : void {
            this.isOpen = false;
        }

        public cancel(): void {
            this.isOpen = false;
        }

        public delete(): void {
            if (this.deleteCallback) {
                this.deleteCallback(this.index);
            }
            this.isOpen = false;
        }
    }
}